import React from 'react';

const Portlet = ({ className = '', children, ...props }) => (
  <div
    className={`portlet ${/\brounded/.test(className) ? '' : 'rounded'} ${className}`}
    {...props}
  >
    {children}
  </div>
);

export default Portlet;
